import styled, { css } from 'styled-components';

export interface StyledHtmlWidgetProps {
  padding?: string;
  margin?: string;
}

const setMargin = (props: StyledHtmlWidgetProps) =>
  props.margin
    ? css`
        margin: ${props.margin};
      `
    : undefined;

const setPadding = (props: StyledHtmlWidgetProps) =>
  props.padding
    ? css`
        padding: ${props.padding};
      `
    : undefined;

export const StyledHtmlWidgetContainer = styled.div`
  ${setMargin}
  ${setPadding}
`;
